/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/5/15 下午4:36
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, ControlLabel, Form, FormGroup, Row, Tab, Tabs } from 'react-bootstrap';
import Error2 from './Error2';
import { connect } from 'react-redux';
import * as actions from '../actions';
import './Login.css';
import axios from 'axios';

const key = Math.random().toString().substring(2, 12);

@connect(
    () => ({
        rapidLoginKey: key
    }),
    {
        onLogin: (username, password, verify) => actions.login(username, password, verify),
        onAutoLogin: (token) => actions.autoLogin(token),
        getVerify: (phone) => actions.getVerify(phone),
        onVerify: (phone, verify) => actions.onVerify(phone, verify)
    }
)
export default class Login extends Component {
    static propTypes = {
        onLogin: PropTypes.func.isRequired,
        onAutoLogin: PropTypes.func.isRequired,
        rapidLoginKey: PropTypes.string.isRequired,
        getVerify: PropTypes.func.isRequired,
        onVerify: PropTypes.func.isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            isSend: false,
            error: '',
            isHide: typeof window !== 'undefined' && window.top !== window.self
        };
    }
    componentDidMount() {
        let { onAutoLogin } = this.props;
        const { isHide } = this.state;
        if (isHide) {
            let adminInfo = sessionStorage.getItem('adminInfo-2');
            if (adminInfo) {
                adminInfo = JSON.parse(adminInfo);
                onAutoLogin(adminInfo.token);
            }
            window.addEventListener('message', (e) => {
                let { type, info } = e.data;
                if (type === 'yinyuejia-admin-2') {
                    sessionStorage.setItem('adminInfo-2', JSON.stringify(info));
                    onAutoLogin(info.token);
                }
            });
        }
    }
    test(phone, password) {
        axios
            .post(`https://glacier.immusician.com/v3/level/tx_sms_login`, {
                username: phone,
                password
            })
            .then((res) => {
                if (res.data.error === 0) {
                    this.setState({ isSend: true });
                } else {
                    this.setState({ error: res.data.msg });
                }
            });
    }
    render() {
        const { onLogin } = this.props;
        const { error, isHide } = this.state;
        return !isHide ? (
            <div className="container" style={{ marginTop: 20, marginBottom: 20 }}>
                <Error2 error={error} onOk={() => this.setState({ error: null })} />
                <Row style={{ marginTop: 100 }}>
                    <Col sm={6} mdPush={3}>
                        <h4>登录</h4>
                        <hr />
                        <Tabs defaultActiveKey={1} id="login_tabs">
                            <Tab eventKey={1} title="帐号密码登录">
                                <Form horizontal className="login-tab-content">
                                    <FormGroup controlId="username">
                                        <Col componentClass={ControlLabel} sm={2}>
                                            用户名
                                        </Col>
                                        <Col sm={10}>
                                            <input
                                                className="form-control"
                                                type="text"
                                                ref="username"
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup controlId="password">
                                        <Col componentClass={ControlLabel} sm={2}>
                                            密码
                                        </Col>
                                        <Col sm={10}>
                                            <input
                                                className="form-control"
                                                type="password"
                                                ref="password"
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup controlId="verify">
                                        <Col componentClass={ControlLabel} sm={2}>
                                            验证码
                                        </Col>
                                        <Col sm={7}>
                                            <input
                                                className="form-control"
                                                type="text"
                                                ref="verify"
                                            />
                                        </Col>
                                        <Col sm={3}>
                                            <Button
                                                type="button"
                                                bsStyle="success"
                                                ref="verbtn"
                                                style={{ display: 'block' }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const phone = this.refs.username.value.trim();
                                                    const password =
                                                        this.refs.password.value.trim();
                                                    this.test(phone, password);
                                                }}
                                            >
                                                {this.state.isSend ? '已发送' : '获取验证码'}
                                            </Button>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup>
                                        <Col smOffset={2} sm={10}>
                                            <Button
                                                type="submit"
                                                bsStyle="success"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const username =
                                                        this.refs.username.value.trim();
                                                    const password =
                                                        this.refs.password.value.trim();
                                                    const verify = this.refs.verify.value.trim();
                                                    onLogin(username, password, verify);
                                                }}
                                            >
                                                登录
                                            </Button>
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </Tab>
                            {/* <Tab eventKey={2} title="验证码登录">
                                <Form horizontal className="login-tab-content">
                                    <FormGroup controlId="phone">
                                        <Col componentClass={ControlLabel} sm={2}>
                                            手机号
                                        </Col>
                                        <Col sm={10}>
                                            <input className="form-control" type="text" ref='phone'/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup controlId='verify'>
                                        <Col componentClass={ControlLabel} sm={2}>
                                            验证码
                                        </Col>
                                        <Col sm={7}>
                                            <input className="form-control" type="text" ref='verify'/>
                                        </Col>
                                        <Col sm={3}>
                                            <Button
                                                type='button'
                                                bsStyle='success'
                                                ref='verbtn'
                                                style={{display: 'block'}}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const phone = this.refs.phone.value.trim();
                                                    getVerify(phone);
                                                }}>
                                                获取验证码
                                            </Button>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup>
                                        <Col smOffset={2} sm={10}>
                                            <Button
                                                type="submit"
                                                bsStyle="success"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const phone = this.refs.phone.value.trim();
                                                    const verify = Number(this.refs.verify.value.trim());
                                                    onVerify(phone, verify);
                                                }}
                                            >
                                                登录
                                            </Button>
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </Tab> */}
                        </Tabs>
                    </Col>
                </Row>
            </div>
        ) : null;
    }
}



// WEBPACK FOOTER //
// src/components/Login.js